module.exports = __webpack_public_path__ + "static/img/release_front.0067fb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/release/release_front.jpg
// module id = E7ct
// module chunks = 0